// extracted by mini-css-extract-plugin
module.exports = {"hideButton":"Customers_hideButton__g6A9Y"};